import axiosNode from '@/axiosInstanceNode.ts'
// Floor plan opt-in status (`is3dScanEligible`) lives on the photographer me
// (airbnb-be-v2), now read through `useMe`.

export const httpFloorPlanDevices = () => axiosNode.get('/v3/navigate/photographers/floor-plan/devices')
export interface FloorPlanOptInPayload {
    airbnb_user_id: string | null
    first_name: string
    last_name: string
    city: string
    country: string
    contact_preference: boolean
    device: string
    terms_accepted: boolean
}

export interface HttpFloorPlanOptInOptions {
    payload: FloorPlanOptInPayload
}

export const httpFloorPlanOptIn = ({payload}: HttpFloorPlanOptInOptions) =>
    axiosNode.post('/v3/navigate/photographers/floor-plan/opt-in', payload)
